import { render, staticRenderFns } from "./CategoryStatus.vue?vue&type=template&id=71da7bf1"
import script from "./CategoryStatus.vue?vue&type=script&lang=js"
export * from "./CategoryStatus.vue?vue&type=script&lang=js"
import style0 from "./CategoryStatus.vue?vue&type=style&index=0&id=71da7bf1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports